module.exports = __webpack_public_path__ + "static/media/Ukraine.5028028b.png";